import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Stack, Grid, CardHeader, Skeleton, Card } from "@mui/material";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import StorageIcon from "@mui/icons-material/Storage";
import { indigo, deepPurple, teal } from "@mui/material/colors";
import { FundsCardType } from "../../lib/fundsAPI";
import { Link } from "react-router-dom";
import styles from "../../styles/fund/fundCard.module.css";
import { toShortNumber } from "../../lib/util";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import AccountBalanceTwoToneIcon from "@mui/icons-material/AccountBalanceTwoTone";
type fundProps = {
  fundData: FundsCardType;
};

export const FundCard = (props: fundProps) => {
  const { fund_id, fund_name, launched_month, quick_stats_data, start_month } =
    props.fundData;

  return (
    <Link to={"/fund/" + fund_id + "/challenges"}>
      <Card className={styles.cardPaper} elevation={4}>
        <CardHeader
          title={fund_name}
          color="textPrimary"
          className={styles.cardHeader}
        />

        <CardContent>
          <Stack>
            <AccountBalanceTwoToneIcon className={styles.cardContent} />
            <Stack direction="row" className={styles.rowStack}>
              <Grid container direction="column" alignItems="center">
                <Grid>
                  <CurrencyExchangeIcon sx={{ color: teal[500] }} />
                </Grid>
                <Typography color="textPrimary">
                  ${toShortNumber(quick_stats_data.fund_budget)}
                </Typography>
                <Typography
                  variant="caption"
                  color="textPrimary"
                  textAlign="center"
                >
                  Budget
                </Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <Grid>
                  <RequestPageOutlinedIcon sx={{ color: teal[500] }} />
                </Grid>
                <Typography color="textPrimary">
                  ${toShortNumber(quick_stats_data.amount_requested)}
                </Typography>
                <Typography variant="caption" color="textPrimary">
                  Requested
                </Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <Box>
                  <DocumentScannerIcon sx={{ color: indigo[400] }} />
                </Box>
                <Typography color="textPrimary">
                  {toShortNumber(quick_stats_data.total_proposals, "comma")}
                </Typography>
                <Typography variant="caption" color="textPrimary">
                  Proposals
                </Typography>
              </Grid>

              <Grid container direction="column" alignItems="center">
                <Box>
                  <StorageIcon sx={{ color: deepPurple[300] }} />
                </Box>
                <Typography color="textPrimary">
                  {quick_stats_data.funded_proposals}
                </Typography>
                <Typography variant="caption" color="textPrimary">
                  Projects
                </Typography>
              </Grid>
            </Stack>
          </Stack>

          <Grid container className={styles.dateBox}>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Launched: {launched_month}
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Started: {start_month}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Link>
  );
};

export const FundCardLoading = () => {
  return (
    <Card className={styles.cardPaper} elevation={4}>
      <Skeleton variant="rectangular" className={styles.skekeltonHeader} />

      <CardContent>
        <Skeleton variant="rectangular" className={styles.skeletonMainIcon} />
        <Grid container className={styles.skeletonIconGrid}>
          <Skeleton variant="rectangular" className={styles.skeletonIcon} />
          <Skeleton variant="rectangular" className={styles.skeletonIcon} />
          <Skeleton variant="rectangular" className={styles.skeletonIcon} />
          <Skeleton variant="rectangular" className={styles.skeletonIcon} />
        </Grid>
        <Skeleton variant="rectangular" className={styles.skeletonDate} />
      </CardContent>
    </Card>
  );
};
